import React from 'react';

import Section from '../../../react4xp/components/Section'
import ContactUs from '../../../react4xp/components/ContactUs'

function ContactUsPart({ title, intro, infobox, columns }) {
	return (
		<Section>
			<ContactUs
				title={title}
				intro={intro}
				infoBoxText={infobox}
				columns={columns}
			/>
		</Section>
	)
}

export default (props) => <ContactUsPart {...props} />
